export default "<ngx-loading-bar></ngx-loading-bar>\n<router-outlet></router-outlet>";